"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _components = require("@folio/stripes/components");
var _reactFinalForm = require("react-final-form");
var _SearchField = _interopRequireDefault(require("../../SearchField"));
var _hooks = require("../../hooks");
var _CustomProperties = _interopRequireDefault(require("../../../../styles/CustomProperties.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const CustomPropertiesLookup = _ref => {
  let {
    contextFilterOptions,
    // expects an array of the form [{value: "OpenAccess", label: "Open Access"}, {value: false, label: "None"}]
    customPropertiesEndpoint: endpoint,
    intlKey: passedIntlKey,
    intlNS: passedIntlNS,
    labelOverrides = {},
    mclProps,
    onSelectCustomProperty,
    queryParams
  } = _ref;
  const [nsValues, setNsValues] = (0, _react.useState)({
    sort: 'label'
  });
  const [selectedContext, setSelectedContext] = (0, _react.useState)();
  const {
    data: custprops,
    isLoading
  } = (0, _hooks.useCustomProperties)({
    endpoint,
    nsValues,
    queryParams,
    returnQueryObject: true,
    ctx: selectedContext,
    options: {
      sort: [{
        path: 'ctx'
      }, {
        path: 'weight'
      }]
    }
  });
  const handleSearch = query => {
    setNsValues({
      ...nsValues,
      query
    });
  };
  const [searchTerm, setSearchTerm] = (0, _react.useState)('');
  const kintIntl = (0, _hooks.useKintIntl)(passedIntlKey, passedIntlNS);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactFinalForm.Form, {
      enableReinitialize: true,
      keepDirtyOnReinitialize: true,
      onSubmit: () => handleSearch(searchTerm),
      children: _ref2 => {
        let {
          handleSubmit
        } = _ref2;
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)("form", {
          className: _CustomProperties.default.lookupSearchContainer,
          onSubmit: handleSubmit,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SearchField.default, {
            ariaLabel: kintIntl.formatKintMessage({
              id: 'customProperties.config.searchAriaLabel',
              overrideValue: labelOverrides.searchAriaLabel,
              fallbackMessage: 'custom-property-search-field'
            }),
            className: _CustomProperties.default.lookupSearch,
            marginBottom0: true,
            onChange: e => setSearchTerm(e.target.value),
            value: searchTerm
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
            buttonClass: _CustomProperties.default.lookupSearchButton,
            buttonStyle: "primary",
            marginBottom0: true,
            type: "submit",
            children: kintIntl.formatKintMessage({
              id: 'search',
              overrideValue: labelOverrides.search
            })
          })]
        });
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Row, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Col, {
        xs: 6,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Select, {
          dataOptions: contextFilterOptions,
          label: kintIntl.formatKintMessage({
            id: 'customProperties.ctx',
            overrideValue: labelOverrides.ctx
          }),
          onChange: e => {
            setSelectedContext(e.target.value);
          },
          value: selectedContext
        })
      })
    }), isLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Spinner, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.MultiColumnList, {
      columnMapping: {
        'label': kintIntl.formatKintMessage({
          id: 'customProperties.label',
          overrideValue: labelOverrides.label
        }),
        'primary': kintIntl.formatKintMessage({
          id: 'customProperties.primary',
          overrideValue: labelOverrides.primary
        }),
        'ctx': kintIntl.formatKintMessage({
          id: 'customProperties.ctx',
          overrideValue: labelOverrides.ctx
        }),
        'weight': kintIntl.formatKintMessage({
          id: 'customProperties.weight',
          overrideValue: labelOverrides.weight
        }),
        'type': kintIntl.formatKintMessage({
          id: 'customProperties.type',
          overrideValue: labelOverrides.type
        }),
        'category': kintIntl.formatKintMessage({
          id: 'customProperties.category',
          overrideValue: labelOverrides.category
        })
      },
      contentData: custprops,
      formatter: {
        primary: data => {
          if (data !== null && data !== void 0 && data.primary) {
            return kintIntl.formatKintMessage({
              id: 'yes',
              overrideValue: labelOverrides.yes
            });
          } else {
            return kintIntl.formatKintMessage({
              id: 'no',
              overrideValue: labelOverrides.no
            });
          }
        },
        type: data => kintIntl.formatKintMessage({
          id: "customProperties.type.".concat(data === null || data === void 0 ? void 0 : data.type),
          overrideValue: labelOverrides === null || labelOverrides === void 0 ? void 0 : labelOverrides[data === null || data === void 0 ? void 0 : data.type]
        }),
        category: data => {
          var _data$category;
          return data === null || data === void 0 || (_data$category = data.category) === null || _data$category === void 0 ? void 0 : _data$category.desc;
        }
      },
      onRowClick: onSelectCustomProperty,
      visibleColumns: ['label', 'primary', 'ctx', 'weight', 'type', 'category'],
      ...mclProps
    })]
  });
};
CustomPropertiesLookup.propTypes = {
  contextFilterOptions: _propTypes.default.arrayOf(_propTypes.default.shape({
    value: _propTypes.default.string,
    label: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.string])
  })),
  customPropertiesEndpoint: _propTypes.default.string,
  intlKey: _propTypes.default.string,
  intlNS: _propTypes.default.string,
  labelOverrides: _propTypes.default.object,
  mclProps: _propTypes.default.object,
  onSelectCustomProperty: _propTypes.default.func,
  queryParams: _propTypes.default.object,
  refdataEndpoint: _propTypes.default.string
};
var _default = exports.default = CustomPropertiesLookup;